import { render, staticRenderFns } from "./clientsEdit.vue?vue&type=template&id=5705df7a"
import script from "./clientsEdit.vue?vue&type=script&lang=js"
export * from "./clientsEdit.vue?vue&type=script&lang=js"
import style0 from "./clientsEdit.vue?vue&type=style&index=0&id=5705df7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports